import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';

import Pagination from '../../Pagination/Pagination';
import { getDetails } from '../../../services/mediaDisplayService';
import { getRestrictionRules } from '../../../actions/publishActions';
import MediaItem from './mediaItem/MediaItem';

import './MediaLibrary.scss';

interface MediaLibraryProps {
	medias: object[];
	totalCount: number;
	page: number;
	rowsPerPage: number;
	onPageChange: (_e: object, _page: number) => void;
	onRowPerPageChange: (_e: any) => void;
}

const MediaLibrary = (
	{
		medias,
		totalCount,
		page,
		rowsPerPage,
		onPageChange,
		onRowPerPageChange,
	}: MediaLibraryProps
) => {
	const { t: translator } = useTranslation();
	const dispatch = useDispatch();
	const refinedMedia = medias.map((media) => getDetails(media));
	const defaultAccountId = useSelector((state) => (state as any).session.defaultAccountId);

	useEffect(() => {
		dispatch(getRestrictionRules(defaultAccountId));
	}, [defaultAccountId, dispatch]);

	return (
		<Box className="media-library-modal-wrapper">
			<Box className="content-wrapper">
				{refinedMedia.length !== 0 && (
					<Box className="media-list">
						{refinedMedia.map((media: any) => {
							const { id } = media;
							return (
								<MediaItem
									translator={translator}
									key={id}
									id={id}
									media={media}
								/>
							);
						})}
					</Box>
				)}
				{refinedMedia.length === 0 && (
					<Box className="empty-medias">
						<Typography variant="body1">{translator('COMMON_NO_MEDIAS_FOUND')}</Typography>
					</Box>
				)}
				<Pagination
					count={Number(totalCount)}
					page={page}
					rowsPerPage={rowsPerPage}
					labelRowsPerPage={`${translator('COMMON_MEDIAS_PER_PAGE')}:`}
					onPageChange={onPageChange}
					onRowsPerPageChange={onRowPerPageChange}
				/>
			</Box>
		</Box>
	);
};

export default MediaLibrary;
